import { ContabilidadContactoDtoProps } from "./DTOs/ContabilidadContactoDto"
import { ContactoConfiguracionReadingDtoProps } from "./DTOs/ContactoConfiguracionReadingDto"
import { ContactoReadingDtoProps } from "./DTOs/ContactoReadingDto"
import { ContactoReadingSimpleDto } from "./DTOs/ContactoReadingSimpleDto"
import { CuentaBancariaContactoReadingDtoProps } from "./DTOs/CuentaBancariaContactoReadingDto"
import { GetSaldoPendienteContactoDtoProps } from "./DTOs/GetSaldoPendienteContactoDto"

export const contactoCtaBancariasByEmpresaIdAdapter = (
  cuenta: CuentaBancariaContactoReadingDtoProps
): CuentaBancariaContactoReadingDtoProps => {
  return {
    id: cuenta.id,
    bic: cuenta.bic,
    canEditBic: cuenta.canEditBic,
    entidadBancariaId: cuenta.entidadBancariaId,
    entidadBancariaNombre: cuenta.entidadBancariaNombre,
    iban: cuenta.iban,
    mandato: {
      fecha: cuenta.mandato?.fecha,
      referencia: cuenta.mandato?.referencia,
    },
    principal: cuenta.principal,
  }
}

export const contactoPreferenciasIdAdapter = (
  preferencias: ContactoConfiguracionReadingDtoProps
): ContactoConfiguracionReadingDtoProps => ({
  delegacion: preferencias?.delegacion,
  descuento: preferencias?.descuento,
  diaDePago: preferencias?.diaDePago,
  formaPago: preferencias?.formaPago,
  referencia: preferencias?.referencia,
  vencimientoDias: preferencias?.vencimientoDias,
})

export const contactoByIdAdapter = (
  contacto: ContactoReadingDtoProps
): ContactoReadingDtoProps => ({
  id: contacto?.id,
  ajustesDocumentoPorDefectoContacto:
    contacto?.ajustesDocumentoPorDefectoContacto,
  cuentasBancarias: contacto?.cuentasBancarias,
  direccion: contacto?.direccion,
  divisa: contacto?.divisa,
  emails: contacto?.emails,
  empresaContactoId: contacto?.empresaContactoId,
  empresaId: contacto?.empresaId,
  etiquetas: contacto?.etiquetas,
  nif: contacto?.nif,
  pais: contacto?.pais,
  razonSocial: contacto?.razonSocial,
  telefonos: contacto?.telefonos,
})

export const getContactoByFiltersAdapter = (
  contacto: ContactoReadingDtoProps
): ContactoReadingDtoProps => ({
  id: contacto.id,
  ajustesDocumentoPorDefectoContacto:
    contacto.ajustesDocumentoPorDefectoContacto?.map((documento) => ({
      id: documento.id,
      ajusteDocumentoPorDefecto: {
        id: documento.ajusteDocumentoPorDefecto?.id,
        clave: documento.ajusteDocumentoPorDefecto?.clave,
        descripcion: documento.ajusteDocumentoPorDefecto?.descripcion,
        esAjusteArticulo: documento.ajusteDocumentoPorDefecto?.esAjusteArticulo,
        tipoDato: documento.ajusteDocumentoPorDefecto?.tipoDato,
        tipoDocumento: documento.ajusteDocumentoPorDefecto?.tipoDocumento,
      },
      defaultValue: documento.defaultValue,
      tipoAjusteDocumentoPorDefecto: documento.tipoAjusteDocumentoPorDefecto,
    })),
  cuentasBancarias: contacto.cuentasBancarias?.map((cuenta) =>
    contactoCtaBancariasByEmpresaIdAdapter(cuenta)
  ),
  direccion: {
    id: contacto.direccion?.id,
    calle: contacto.direccion?.calle,
    codigoPostal: contacto.direccion?.codigoPostal,
    esFiscal: contacto.direccion?.esFiscal,
    poblacionExtranjera: contacto.direccion?.poblacionExtranjera,
    poblacionId: contacto.direccion?.poblacionId,
    poblacionNombre: contacto.direccion?.poblacionNombre,
    provinciaId: contacto.direccion?.provinciaId,
    provinciaNombre: contacto.direccion?.provinciaNombre,
  },
  divisa: contacto.divisa,
  emails: contacto.emails?.map((email) => ({
    id: email.id,
    contacto: email.contacto,
    nombre: email.nombre,
    principal: email.principal,
    tipoFormaContacto: email.tipoFormaContacto,
  })),
  empresaContactoId: contacto.empresaContactoId,
  empresaId: contacto.empresaId,
  etiquetas: contacto.etiquetas?.map((etiqueta) => etiqueta),
  nif: contacto.nif,
  pais: contacto.pais,
  razonSocial: contacto.razonSocial,
  telefonos: contacto.telefonos?.map((telefono) => ({
    id: telefono.id,
    contacto: telefono.contacto,
    nombre: telefono.nombre,
    principal: telefono.principal,
    tipoFormaContacto: telefono.tipoFormaContacto,
  })),
})

export const getContactoSaldoPendienteAdapter = (
  contactoSaldo: GetSaldoPendienteContactoDtoProps
): GetSaldoPendienteContactoDtoProps => {
  return {
    saldoCobro: contactoSaldo.saldoCobro,
    saldoPago: contactoSaldo.saldoPago,
  }
}

export const contactoByFilterSimpleAdapter = (
  contactoSimple: ContactoReadingSimpleDto
): ContactoReadingSimpleDto => {
  return {
    id: contactoSimple.id,
    empresaContactoId: contactoSimple.empresaContactoId,
    razonSocial: contactoSimple.razonSocial,
  }
}

export const getContactoContabilidadByIdAdapter = (
  contactoContabilidad: ContabilidadContactoDtoProps
): ContabilidadContactoDtoProps => ({
  cuentaContableClienteId: contactoContabilidad.cuentaContableClienteId,
  cuentaContableCompraId: contactoContabilidad.cuentaContableCompraId,
  cuentaContableProveedorId: contactoContabilidad.cuentaContableProveedorId,
  cuentaContableVentaId: contactoContabilidad.cuentaContableVentaId,
  impuestosCompra: contactoContabilidad.impuestosCompra,
  impuestosVenta: contactoContabilidad.impuestosVenta,
})
